<!-- 
程式：ODAVF102.vue
功能：3.4月全站活動需求
作者：i9400540 施義濃
完成：2020-02-15
-->
<template>
  <div class="content_font">
    <div class="l-container">
      <div class="o-menuMask"></div>
      <header
        class="l-header"
        style="width: 100%; position: fixed; z-index: 99; margin-top: -8px"
      >
        <div class="l-header__wrap">
          <div class="l-header__content">
            <div class="l-header__logo">
              <a href="javascript:;" id="CI_Link">
                <picture>
                  <source
                    srcset="@/assets/webpage/action1/images/logo/logo-m.svg"
                    media="(max-width: 1040px)"
                  />
                  <img
                    srcset="@/assets/webpage/action1/images/logo/logo.svg"
                    class="o-logo"
                    style="height:32px;width:auto;vertical-align:middle;"
                  />
                </picture>
              </a>
              <a
                :href="VUE_APP_LINK_WTHOME"
                target="_blank"
                title="回網路投保首頁"
                style="margin-left:32px;"
              >
                <span>網路投保</span>
              </a>
            </div>
          </div>
          <nav class="l-nav">
            <ul class="c-menu" data-tab-sliders>
              <li class="c-menu__item c-menu__item--normal">
                <a
                  href="javascript:;"
                  class="c-menu__text c-menu__text--noChild"
                  @click="scrollAnchor('section1')"
                  >旅平險週週抽</a
                >
              </li>
              <li class="c-menu__item c-menu__item--normal">
                <a
                  href="javascript:;"
                  class="c-menu__text c-menu__text--noChild"
                  @click="scrollAnchor('section2')"
                  >年金險樂富遊</a
                >
              </li>
              <li class="c-menu__item c-menu__item--normal">
                <a
                  href="javascript:;"
                  class="c-menu__text c-menu__text--noChild"
                  @click="scrollAnchor('section3')"
                  >保障型保安心</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <main class="l-main" style="margin-top: 60px">
        <!-- KV -->
        <section class="l-mainKv">
          <div class="l-mainKv__slider slick-initialized slick-slider">
            <div class="slick-list draggable">
              <div
                class="o-banner"
                style="width: 100%; display: inline-block; margin-top: 5px"
              >
                <picture>
                  <source
                    srcset="@/assets/webpage/action2/images/kv/kv_800x900.jpg"
                    media="(max-width: 767px)"
                  />
                  <source
                    srcset="@/assets/webpage/action2/images/kv/kv_1200x1920.jpg"
                    media="(max-width: 1023px)"
                  />
                  <img
                    srcset="@/assets/webpage/action2/images/kv/kv_1600x600.jpg"
                    class="o-banner__photo"
                    alt
                  />
                </picture>
              </div>
            </div>
          </div>
        </section>
        <!-- section1 -->
        <span class="anchor" id="section1"></span>
        <section class="l-mainProduct">
          <div class="l-wrap">
            <div class="c-pdContent">
              <div class="c-pdContent__head">
                <h2
                  class="l-insurancePlan__title o-heading"
                  id="section1"
                  style="margin: 20px 10px"
                >
                  走吧！保平安還可週週抽好禮！
                  <br />旅行路上，GoPro、RIMOWA行李箱、Apple Watch陪伴您！
                </h2>
              </div>
            </div>
            <div class="l-pageTab__section">
              <div class="c-adCard">
                <div class="c-adCard__img">
                  <picture>
                    <source
                      srcset="
                        @/assets/webpage/action2/images/section1/section1_450x280.jpg
                      "
                      media="(max-width: 767px)"
                    />
                    <source
                      srcset="
                        @/assets/webpage/action2/images/section1/section1_450x280.jpg
                      "
                      media="(max-width: 1023px)"
                    />
                    <img
                      srcset="
                        @/assets/webpage/action2/images/section1/section1_450x280.jpg
                      "
                      alt="走吧！保平安還可週週抽好禮！"
                    />
                  </picture>
                </div>
                <div class="c-adCard__text">
                  <div class="c-adCard__title">
                    <h2 class="t2 o-titleBlack">投保旅平險，好禮週週抽！</h2>
                  </div>
                  <p style="text-align: justify">
                    活動辦法 :
                    <br />投保旅平險單筆保費達 800 元(含)，獲1次抽獎機會，
                    滿1,100元(含)獲2次抽獎機會！
                    <br />
                    <font color="#ff7b00">指定團險客戶再加碼抽！</font>
                  </p>
                  <div
                    class="card_button"
                    style="text-align: center; margin-top: 50px"
                  >
                    <a
                      :href="VUE_APP_LINK_INSURED1"
                      target="_blank"
                      class="o-btn o-btn--normal o-btn--primary chkeventOffer"
                      id="ins_travel"
                      >立即投保</a
                    >
                  </div>
                </div>
                <table style="margin: 0 auto; word-break: keep-all">
                  <tr>
                    <td>
                      <table
                        class="c-grid c-grid--view c-table-font-size"
                        style="
                          margin-top: 3%;
                          word-wrap: break-word;
                          table-layout: fixed;
                          text-align: center;
                        "
                      >
                        <tbody>
                          <tr>
                            <td style="background: #dbf1dc; width: 20%">
                              GoPro
                              <br />(1名/週，共3名)
                            </td>
                            <td>3/1~3/7</td>
                            <td>3/8~3/14</td>
                            <td>3/15~3/21</td>
                          </tr>
                          <tr>
                            <td style="background: #dbf1dc; width: 20%">
                              RIMOWA行李箱
                              <br />(1名/週，共3名)
                            </td>
                            <td>3/22~3/28</td>
                            <td>3/29~4/4</td>
                            <td>4/5~4/11</td>
                          </tr>
                          <tr>
                            <td style="background: #dbf1dc; width: 20%">
                              Apple Watch
                              <br />(2名/週，共6名)
                            </td>
                            <td>4/12~4/18</td>
                            <td>4/19~4/25</td>
                            <td>4/26~4/30</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <!-- section2 -->
        <span class="anchor" id="section2"></span>
        <section class="l-indexAd">
          <div class="l-wrap">
            <div class="c-pdContent">
              <div class="c-pdContent__head">
                <h2
                  class="l-insurancePlan__title o-heading"
                  id="section2"
                  style="margin: 0px 10px"
                >
                  投保年金險、保障型商品
                  <br />ezTravel兩萬元抵用金等你抽！
                </h2>
              </div>
            </div>
            <div class="l-mainProduct__container">
              <div class="l-cols__6 l-cols__6@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__main">
                    <div class="c-productCard__imgContainer">
                      <a
                        :href="VUE_APP_LINK_INSURED2"
                        target="_blank"
                        id="insurance01PIC"
                      >
                        <picture>
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section2/section2_1_580x490.jpg
                            "
                            media="(max-width: 767px)"
                          />
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section2/section2_1_270x225.jpg
                            "
                            media="(max-width: 1023px)"
                          />
                          <img
                            srcset="
                              @/assets/webpage/action2/images/section2/section2_1_270x225.jpg
                            "
                            class="c-productCard__img c-productCard__img_2 picturefill-background"
                            style="
                              background-size: cover;
                              background-repeat: no-repeat;
                              background-position: 50% 50%;
                            "
                          />
                        </picture>
                      </a>
                    </div>
                    <div class="c-productCard__content">
                      <div class="c-productCard__title">
                        <a :href="VUE_APP_LINK_INSURED2" target="_blank"
                          >iMoney利變年金險</a
                        >
                      </div>
                      <p class="c-productCard__desc">
                        分期繳達3,000元(含)，即有一次抽獎機會。
                      </p>
                    </div>
                  </div>
                  <div class="c-productCard__links">
                    <div class="c-productCard__linkbox">
                      <a
                        :href="VUE_APP_LINK_INSURED2"
                        id="ins_imoney"
                        class="c-productCard__linkbox--item o-link o-link--normal"
                        target="_blank"
                      >
                        <span>立即投保</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="l-cols__6 l-cols__6@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__main">
                    <div class="c-productCard__imgContainer">
                      <a
                        :href="VUE_APP_LINK_INSURED3"
                        target="_blank"
                        id="insurance02PIC"
                      >
                        <picture>
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section2/section2_2_580x490.jpg
                            "
                            media="(max-width: 767px)"
                          />
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section2/section2_2_270x225.jpg
                            "
                            media="(max-width: 1023px)"
                          />
                          <img
                            srcset="
                              @/assets/webpage/action2/images/section2/section2_2_270x225.jpg
                            "
                            class="c-productCard__img c-productCard__img_2 picturefill-background"
                            style="
                              background-size: cover;
                              background-repeat: no-repeat;
                              background-position: 50% 50%;
                            "
                          />
                        </picture>
                      </a>
                    </div>
                    <div class="c-productCard__content">
                      <div class="c-productCard__title">
                        <a :href="VUE_APP_LINK_INSURED3" target="_blank"
                          >鑫Money利變年金險</a
                        >
                      </div>
                      <p class="c-productCard__desc">
                        投保利變年金險每10萬元獲2次抽獎機會，20 萬元獲
                        4次抽獎機會，依此類推。
                        <font color="#ff7b00">指定團險客戶再加碼抽！</font>
                      </p>
                    </div>
                  </div>
                  <div class="c-productCard__links">
                    <div class="c-productCard__linkbox">
                      <a
                        :href="VUE_APP_LINK_INSURED3"
                        id="ins_smoney"
                        class="c-productCard__linkbox--item o-link o-link--normal"
                        target="_blank"
                      >
                        <span>立即投保</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- section3 -->
        <span class="anchor" id="section3"></span>
        <section class="l-mainProduct">
          <div class="l-wrap">
            <h2
              class="l-mainProduct__title o-heading"
              id="section3"
              style="margin: 0px 10px"
            >
              保障型商品
              <br />保了好安心~投保更可獲2次抽獎機會！
            </h2>
            <div class="c-pdContent">
              <div class="c-pdContent__head">
                <p class="c-productCard__desc" style="text-align: center">
                  [加碼抽]
                  投保iCarry搭車族、騎士族、逍遊族方案，額外獲得3次抽獎機會！
                </p>
              </div>
            </div>
            <div class="l-mainProduct__container">
              <div class="l-cols__3 l-cols__6@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__main">
                    <div class="c-productCard__imgContainer">
                      <a
                        :href="VUE_APP_LINK_INSURED4"
                        target="_blank"
                        id="insurance03PIC"
                      >
                        <picture>
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_1_580x490.jpg
                            "
                            media="(max-width: 767px)"
                          />
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_1_270x225.jpg
                            "
                            media="(max-width: 1023px)"
                          />
                          <img
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_1_270x225.jpg
                            "
                            class="c-productCard__img picturefill-background"
                          />
                        </picture>
                      </a>
                    </div>
                    <div class="c-productCard__content">
                      <div class="c-productCard__title">
                        <a :href="VUE_APP_LINK_INSURED4" target="_blank"
                          >iLove小額終身壽險</a
                        >
                      </div>
                      <p class="c-productCard__desc c-productCard_desc_height">
                        iLove保險費較一般終身壽險便宜，約為現行市面上終身壽險的7~8折，可用實惠保費為心愛家人預留保障
                      </p>
                    </div>
                  </div>
                  <div class="c-productCard__links">
                    <div class="c-productCard__linkbox">
                      <a
                        :href="VUE_APP_LINK_INSURED4"
                        id="ins_life_i"
                        class="c-productCard__linkbox--item o-link o-link--normal"
                        target="_blank"
                      >
                        <span>立即投保</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="l-cols__3 l-cols__6@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__main">
                    <div class="c-productCard__imgContainer">
                      <a
                        :href="VUE_APP_LINK_INSURED5"
                        target="_blank"
                        id="insurance04PIC"
                      >
                        <picture>
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_2_580x490.jpg
                            "
                            media="(max-width: 767px)"
                          />
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_2_270x225.jpg
                            "
                            media="(max-width: 1023px)"
                          />
                          <img
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_2_270x225.jpg
                            "
                            class="c-productCard__img picturefill-background"
                          />
                        </picture>
                      </a>
                    </div>
                    <div class="c-productCard__content">
                      <div class="c-productCard__title">
                        <a :href="VUE_APP_LINK_INSURED5" target="_blank"
                          >iCarry意外傷害險</a
                        >
                      </div>
                      <p class="c-productCard__desc c-productCard_desc_height">
                        涵蓋您的意外保障與生活的保險。依據您的生活型態，任選「搭車族」、「騎士族」、「逍遊族」，將可獲得額外意外事故保障
                      </p>
                    </div>
                  </div>
                  <div class="c-productCard__links">
                    <div class="c-productCard__linkbox">
                      <a
                        :href="VUE_APP_LINK_INSURED5"
                        id="ins_icarry"
                        class="c-productCard__linkbox--item o-link o-link--normal"
                        target="_blank"
                      >
                        <span>立即投保</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="l-cols__3 l-cols__6@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__main">
                    <div class="c-productCard__imgContainer">
                      <a
                        :href="VUE_APP_LINK_INSURED6"
                        target="_blank"
                        id="insurance02PIC"
                      >
                        <picture>
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_3_580x490.jpg
                            "
                            media="(max-width: 767px)"
                          />
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_3_270x225.jpg
                            "
                            media="(max-width: 1023px)"
                          />
                          <img
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_3_270x225.jpg
                            "
                            class="c-productCard__img picturefill-background"
                          />
                        </picture>
                      </a>
                    </div>
                    <div class="c-productCard__content">
                      <div class="c-productCard__title">
                        <a :href="VUE_APP_LINK_INSURED6" target="_blank"
                          >新e路平安險 意外傷害險</a
                        >
                      </div>
                      <p class="c-productCard__desc c-productCard_desc_height">
                        保障涵蓋範圍廣，全方位保護您的生活
                      </p>
                    </div>
                  </div>
                  <div class="c-productCard__links">
                    <div class="c-productCard__linkbox">
                      <a
                        :href="VUE_APP_LINK_INSURED6"
                        id="ins_eacc"
                        class="c-productCard__linkbox--item o-link o-link--normal"
                        target="_blank"
                      >
                        <span>立即投保</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="l-cols__3 l-cols__6@t l-cols__12@m">
                <div class="c-productCard">
                  <div class="c-productCard__main">
                    <div class="c-productCard__imgContainer">
                      <a
                        :href="VUE_APP_LINK_INSURED7"
                        target="_blank"
                        id="insurance01PIC"
                      >
                        <picture>
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_4_580x490.jpg
                            "
                            media="(max-width: 767px)"
                          />
                          <source
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_4_270x225.jpg
                            "
                            media="(max-width: 1023px)"
                          />
                          <img
                            srcset="
                              @/assets/webpage/action2/images/section3/section3_4_270x225.jpg
                            "
                            class="c-productCard__img picturefill-background"
                          />
                        </picture>
                      </a>
                    </div>
                    <div class="c-productCard__content">
                      <div class="c-productCard__title">
                        <a :href="VUE_APP_LINK_INSURED7" target="_blank"
                          >新e把罩 定期壽險</a
                        >
                      </div>
                      <p class="c-productCard__desc c-productCard_desc_height">
                        期滿更約保證，保障延續不中斷
                      </p>
                    </div>
                  </div>
                  <div class="c-productCard__links">
                    <div class="c-productCard__linkbox">
                      <a
                        :href="VUE_APP_LINK_INSURED7"
                        id="ins_life_e"
                        class="c-productCard__linkbox--item o-link o-link--normal"
                        target="_blank"
                      >
                        <span>立即投保</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- section4 -->
        <span class="anchor" id="section4"></span>
        <section class="l-indexAd">
          <div class="l-wrap">
            <h2
              class="l-insurancePlan__title o-heading"
              style="text-align: center"
            >
              &lt;領獎及抽獎方式&gt;
            </h2>
            <div
              class="l-pageTab__content u-gutterNext--md"
              style="margin: 0 atuo"
            >
              <p>
                本公司將於活動期間屆滿後一個月內，以電腦隨機抽獎。並於抽獎日後一個月內，於本活動網站公告得獎名單，且以Email方式各別通知得獎者。得獎者須於抽獎日後15日內完成領獎，逾期未領獎者，視為放棄得獎資格。
              </p>
              <p>
                投保旅行平安險、儲蓄型保險或保障型保險需完成繳費且無撤銷或解約之情事，具有抽獎資格。
              </p>
            </div>
          </div>
        </section>
        <section class="l-indexAd">
          <div class="l-wrap">
            <h2
              class="l-insurancePlan__title o-heading"
              style="text-align: center"
            >
              &lt;注意事項&gt;
            </h2>
            <div
              class="l-pageTab__content u-gutterNext--md"
              style="margin: 0 atuo"
            >
              <ul class="o-list o-list--decimal">
                <li>本活動限自然人參加。</li>
                <li>本公司指定企業如下，</li>
                <table>
                  <tbody>
                    <tr>
                      <td data-title="合作夥伴">
                        <div class="l-pdTable">
                          <table class="c-grid c-grid--view">
                            <tbody>
                              <tr>
                                <td
                                  style="
                                    background: #dbf1dc;
                                    word-break: keep-all;
                                  "
                                  rowspan="11"
                                >
                                  企業名稱
                                </td>
                                <td>全漢企業股份有限公司</td>
                              </tr>
                              <tr>
                                <td>全漢企業股份有限公司高雄分公司</td>
                              </tr>
                              <tr>
                                <td>向漢科技有限公司</td>
                              </tr>
                              <tr>
                                <td>富創源股份有限公司</td>
                              </tr>
                              <tr>
                                <td>善元科技股份有限公司</td>
                              </tr>
                              <tr>
                                <td>天主教若瑟醫療財團法人</td>
                              </tr>
                              <tr>
                                <td>財團法人天主教若瑟社會福利基金會</td>
                              </tr>
                              <tr>
                                <td>兆聯實業股份有限公司</td>
                              </tr>
                              <tr>
                                <td>信和材料科技股份有限公司</td>
                              </tr>
                              <tr>
                                <td>兆聯技術服務有限公司</td>
                              </tr>
                              <tr>
                                <td>亦則檢測科技有限公司</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  上述指定企業員工需於2020/03/01~2020/04/30投保時，於合作夥伴活動登錄點選「團險企業客戶專案」，如未於投保時點選，視同放棄增加抽獎機會，且投保完成後亦不得補登錄。投保之保險商品須經本公司同意承保且無契約撤回情事。
                </p>

                <li>
                  參加者於參加本活動時，即表示同意本活動辦法，並充分知悉與同意以下事項:
                  <p>
                    本公司得因本活動之需要，依個人資料保護相關規定，於參加者同意之期間內，以電子檔或紙本形式於我國境內蒐集、處理、利用其個人資料。但本公司於未經參加者之同意下，不得利用參加者之個人資料進行商業行銷行為。參加者可自由選擇是否提供完整個人資訊，惟若資訊不完整者，將無法參加本活動。
                  </p>
                  <p>
                    參加者可電洽本公司免費客服專線(0800-036-599)，針對其個人資料行使請求答覆查詢、提供閱覽、製給複製本、更正、補充、停止蒐集、處理、利用或刪除之權利，亦可至本公司官方網站法令公告之「個人資料保護法」應告知事項專區
                    (網址：https://www.cathayholdings.com/life/B2CWebGroup/pages/privacy/privacylist.html)進一步了解詳細資訊。
                  </p>
                </li>
                <li>
                  本活動獎項「ezTravel旅遊憑證」係以紙本抵用券方式交付予得獎者，其使用規定如下：
                </li>
                <ul class="o-list o-list--decimal">
                  (1)
                  本憑證可兌換易遊網平台配合廠商之商品(EMONEY紅利點數兌換之商品除外)。
                  <br />(2)
                  本憑證兌換時需攜帶正本或可於付款期限內將正本掛號寄至易遊網公司，恕不受理影本。
                  <br />(3)
                  本憑證限一次兌換完畢，抵用時恕無法找零，亦不可折換現金。
                  <br />(4)
                  兌換產品以易遊網站上公告及本憑證內容限制為準，如消費超過可抵用金額部分，請以易遊網站公告之消費方式補足。
                  <br />(5) 本憑證無使用期限。
                  <br />(6) 未盡事宜悉依兌換旅遊商品之銷售約定及使用規則為準。
                </ul>
                <li>
                  本活動如有任何因電腦、網路、電話、技術或其他不可歸責於本公司之事由，致參加者所寄出、填寫或登錄之資料有遺失、錯誤、無法辨識或毀損等情形，本公司不負任何法律責任。
                </li>
                <li>
                  本公司有權檢視得獎情況是否有人為操作之行為，對於以偽造、詐欺或其他不正當之方式意圖兌領之參加者，本公司有權撤銷其得獎資格或拒絕其參與本活動。
                </li>
                <li>
                  得獎者身分之認定係依本公司資料庫電子郵件所對應（或參加者所填寫、登錄）之身分證字號為主，得獎者須提供正確之身分證影本，並經本公司確認無誤後始得領獎。
                </li>
                <li>
                  本活動獎品寄送地址僅限中華民國境內，如得獎者未能於領獎期限前回覆有效國內寄送地址，本公司得取消其得獎資格。
                </li>
                <li>
                  得獎者逾期未領獎或因留存資料不完整或錯誤致無法通知得獎者，視同放棄得獎資格，不接受開立扣繳憑單者，亦同。
                </li>
                <li>本活動獎品不得要求轉換、轉讓或折換現金。</li>
                <li>
                  本活動獎品悉以實物為準，網頁上照片、圖案等僅供參考，恕不挑色；如遇缺貨或不可抗力之因素無法提供時，本公司有權以其他等值商品替代。
                </li>
                <li>
                  依稅法規定，得獎者若為中華民國境內居住之個人，且年度所得獎項價值累積超過1,000元時，本公司將於翌年開立所得稅扣繳憑單予得獎者，如所得獎項價值達20,010元(含)時，得獎者須先繳交10%機會中獎稅金，始可領獎。得獎者若為非中華民國境內居住之個人(即在中華民國境內居住未達183天之本國人及外國人)，不論得獎獎項價值，均須先就得獎所得扣繳20%機會中獎稅金，始可領獎，本公司並將依法開立所得稅扣繳憑單。若未能依法繳納應繳稅額，即視為喪失得獎資格。參加者因參加本活動而須支付之任何稅捐皆為參加者之義務，概與本公司無關。前述稅捐法規如有更新或變動者，依修正後之規定辦理。
                </li>
                <li>
                  本公司非獎品製造者或提供者，與各項獎品或服務之製造或提供廠商無任何代理或合夥關係，且本活動獎品之保固期限均依廠商出廠時實際提供者為準。得獎者如因本活動各項獎品、服務或保固發生任何爭議，概與本公司無關。
                </li>
                <li>
                  本公司保有取消、終止、修改或暫停本活動相關內容之權利，並得以公告方式通知參加者。如有未盡事宜，悉依本公司相關規定或解釋辦理。
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
      <footer class="l-footer">
        <div class="l-footer__contactUs">
          <div class="l-footer__wrap">
            <ul class="c-footLinks">
              <li>
                <a
                  :href="VUE_APP_LINK_MEMBER"
                  target="_blank"
                  class="c-footLinks__link"
                  >會員專區</a
                >
              </li>
              <li>
                <a
                  :href="VUE_APP_LINK_CONNECTION"
                  target="_blank"
                  class="c-footLinks__link"
                  >聯絡我們</a
                >
              </li>
              <li>
                <a
                  :href="VUE_APP_LINK_SECRET"
                  target="_blank"
                  class="c-footLinks__link"
                  >顧客資料保密措施</a
                >
              </li>
              <li></li>
            </ul>
          </div>
        </div>
        <div class="l-footer__copyright">
          <div class="l-footer__wrap">© 國泰人壽保險股份有限公司</div>
        </div>
      </footer>
      <a href="javascript:;" class="o-gotoTop" data-id="gotop"></a>
    </div>
    <div id="CI_LINK_MSG" class="mfp-hide" style="width: 30%; margin: 0 auto">
      <div class="c-popup__head" data-alert="title">提醒您</div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content">您將離開本頁面，並前往國泰人壽官網首頁。</div>
        <div class="c-popup__actions">
          <a
            href="javascript:;"
            class="o-btn o-btn--normal"
            style="margin-right: 5px"
            data-mfp-close
            >取消</a
          >
          <a
            @click="gotoCathayLife"
            class="o-btn o-btn--normal o-btn--primary"
            style="margin-left: 5px"
            >立即前往</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import "magnific-popup/dist/magnific-popup.css";
import "magnific-popup";

export default {
  name: "ODAVF102",
  data() {
    return {
      isLogin: false,
      req: {
        BASIC_LIFE: "0",
        BASIC_ACCIDENT: "0",
        BASIC_TRAVEL: "0",
        DOUBLE_LIFE: "0",
        DOUBLE_ACCIDENT: "0",
        DOUBLE_TRAVEL: "0",
      },
      msg: "請先登入",
      //國泰人壽首頁
      VUE_APP_LINK_CATHAYLIFE: process.env.VUE_APP_LINK_CATHAYLIFE,
      //網路投保首頁
      VUE_APP_LINK_WTHOME: process.env.VUE_APP_LINK_WTHOME,
      //會員專區
      VUE_APP_LINK_MEMBER: process.env.VUE_APP_LINK_MEMBER,
      //聯絡我們
      VUE_APP_LINK_CONNECTION: process.env.VUE_APP_LINK_CONNECTION,
      //顧客資料保密措施
      VUE_APP_LINK_SECRET: process.env.VUE_APP_LINK_SECRET,
      //立即投保-1(旅平險)
      VUE_APP_LINK_INSURED1:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIB0_1000/prompt",
      //立即投保-2(iMoney)
      VUE_APP_LINK_INSURED2:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIC0_1000/prompt",
      //立即投保-3(鑫Money)
      VUE_APP_LINK_INSURED3:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIC1_1000/prompt",
      //立即投保-4(iLove)
      VUE_APP_LINK_INSURED4:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIE2_1000/prompt",
      //立即投保-5(iCarry)
      VUE_APP_LINK_INSURED5:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OID0_1000/prompt",
      //立即投保-6(新e路平安)
      VUE_APP_LINK_INSURED6:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OID1_1000/prompt",
      //立即投保-7(新e把罩壽險)
      VUE_APP_LINK_INSURED7:
        "https://online.cathaylife.com.tw/OIWeb/servlet/HttpDispatcher/OIE3_1000/prompt",
    };
  },
  created() {
    import("@/assets/webpage/js/vendor/modernizr-3_5_0-min.js").then((m) => {});

    import("@/assets/webpage/js/vendor/picturefill/picturefill-min.js").then(
      (m) => {}
    );
    import("@/assets/webpage/js/vendor/picturefill/pf-mutation-min.js").then(
      (m) => {}
    );
    import("@/assets/webpage/js/vendor/matchMedia/matchMedia-min.js").then(
      (m) => {}
    );
    import(
      "@/assets/webpage/js/vendor/jquery-fancyform/jquery-fancyform-min.js"
    ).then((m) => {});
    import("@/assets/webpage/js/vendor/slick/slick.js").then((m) => {});
  },
  mounted() {
    this.$nextTick(() => {
      this.initFun();
    });
  },
  methods: {
    // 前往國泰人壽
    gotoCathayLife() {
      window.location.href = this.VUE_APP_LINK_CATHAYLIFE;
    },
    scrollAnchor(id) {
      let animationTime = {
        type: Number,
        default: 300,
      };
      let move = $("#" + id).offset().top - 65;
      $("html").animate({ scrollTop: move }, this.animationTime);
    },
    initFun() {
      $("#CI_Link").on("click", function (e) {
        e.preventDefault();
        $.magnificPopup.open({
          items: {
            src: "#CI_LINK_MSG",
            type: "inline",
          },
          callbacks: {
            open: function () {
              $("#CI_LINK_MSG_Link1").on("click", function (e) {
                e.preventDefault();
                window.location = VUE_APP_LINK_CATHAYLIFE;
              });

              $("#CI_LINK_MSG .o-btn--normal[data-mfp-close]").on(
                "click",
                function (e) {
                  e.preventDefault();
                  $.magnificPopup.close();
                }
              );
            },
          },
        });
      });
    },
  },
};
</script>
<style
  src="@/assets/webpage/css/jquery_fancyform/jquery_fancyform_min.css"
></style>
<style scoped src="@/assets/webpage/js/vendor/slick/slick-min.css"></style>
<style
  scoped
  src="@/assets/webpage/js/vendor/slick/slick-theme-min.css"
></style>
<style
  scoped
  src="@/assets/webpage/js/vendor/bootstrap-datepicker/bootstrap-datepicker.standalone.min.css"
></style>
<style scoped src="@/assets/webpage/css/common/normalize-min.css"></style>
<style scoped src="@/assets/webpage/css/common/animate-min.css"></style>
<style scoped src="@/assets/webpage/css/common/layout-min.css"></style>
<style scoped src="@/assets/webpage/css/form-min.css"></style>
<style scoped src="@/assets/webpage/css/product-min.css"></style>
<style scoped src="@/assets/webpage/css/index.css"></style>
<style scoped src="@/assets/webpage/css/common/main.css"></style>
<style scoped src="@/assets/third-party/css/font-awesome.min.css"></style>

<style scoped>
.c-popup__content {
  background-color: white;
}
@media only screen and (min-width: 1025px) {
  .c-table-font-size {
    font-size: 16px;
  }
  .c-productCard_desc_height {
    height: 140px;
  }

  .c-productCard__img_2 {
    height: 290px !important;
    width: 75%;
    margin: 0 57px;
  }
  .customHeight {
    height: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .c-table-font-size {
    font-size: 16px;
  }
  .c-productCard_desc_height {
    height: 70px;
  }
  .c-productCard__img,
  .c-productCard__img_2 {
    height: 290px !important;
  }
}

@media only screen and (max-width: 768px) {
  .c-table-font-size {
    font-size: 14px;
  }
}

@media only screen and (min-width: 768px) {
  .l-mainProduct__container {
    max-height: 1140px !important;
  }
}
.c-productCard__title {
  height: auto;
}

.c-grid tbody td {
  border: 1px solid #dbf1dc !important;
}
</style>

<style scoped>
.content_font {
  font-size: 16px;
  line-height: 1.5;
  color: #666;
  font-family: Arial, "Microsoft JhengHei", Helvetica, sans-serif;
}
</style>
